export const PageNames = {
  ABOUT:'About',
  CONTACT:'Contact',
  PROJECTS:'Projects',
  EXPERIMENTS:'Experiments',
  PRESS:'Press',
}

export const pageLocations = {
  [PageNames.ABOUT]:'/about',
  [PageNames.CONTACT]:'/contact',
  [PageNames.PROJECTS]:'/',
  [PageNames.EXPERIMENTS]:'/experiments',
  [PageNames.PRESS]:'/press',
}



// WEBPACK FOOTER //
// ./src/modules/menu/pageInfo.js